import "./App.css";

import { AllRoutes } from "../src/components/AllRoutes";
function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
